<template>
  <div class="signin-wrapper">
    <!-- Ladezustand: config.json wird gelesen -->
    <LoadingOverlay
      :is-loading="isLoading"
      message="Anmeldung wird vorbereitet..."
    />

    <!-- Fehlerzustand: config.json konnte nicht geladen werden -->
    <div
      v-if="hasError && !isLoading"
      class="signin-card"
    >
      <div class="card-logo">
        <img
          src="@/assets/images/logo-penstec.png"
          alt="PensExpert"
        >
      </div>
      <div class="error-box">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
        <span>
          Die Anmeldekonfiguration konnte nicht geladen werden.
          Bitte laden Sie die Seite neu oder wenden Sie sich an den Support.
        </span>
      </div>
    </div>

    <!-- Auswahlseite: bei ≥2 konfigurierten Options -->
    <div
      v-if="showSelection && !isLoading"
      class="signin-card"
    >
      <div class="card-logo">
        <img
          src="@/assets/images/logo-penstec.png"
          alt="PensExpert"
        >
      </div>

      <p class="card-title">
        Herzlich willkommen
      </p>
      <p class="card-subtitle">
        Wie möchten Sie sich anmelden?
      </p>

      <div
        class="options-grid"
        :class="{ 'has-multiple-columns': options.length >= 4 }"
      >
        <button
          v-for="option in options"
          :key="option.url"
          class="option-tile"
          :class="`type-${option.type}`"
          @click="navigateTo(option.url)"
        >
          <div class="tile-icon">
            <font-awesome-icon :icon="['fas', option.icon || 'arrow-right']" />
          </div>
          <div class="tile-text">
            <div class="tile-name">
              {{ option.name }}
            </div>
            <div
              v-if="option.description"
              class="tile-description"
            >
              {{ option.description }}
            </div>
          </div>
          <div class="tile-arrow">
            <font-awesome-icon :icon="['fas', 'chevron-right']" />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import configService from '@/services/configService';

const isLoading = ref(true);
const hasError = ref(false);
const options = ref([]);

// Kachel-Auswahl nur wenn ≥2 Options konfiguriert
const showSelection = computed(() => options.value.length >= 2);

function navigateTo(url) {
  window.location.href = url;
}

onMounted(async () => {
  try {
    isLoading.value = true;

    const resolved = await configService.getOptions();

    if (resolved.length === 0) {
      // 0 Options: direkt zum Standard-Login weiterleiten (kein UI)
      window.location.replace('/auth/login');
      return;
    }

    if (resolved.length === 1) {
      // 1 Option: direkt weiterleiten (wie HTTP 301, kein Back-Button)
      window.location.replace(resolved[0].url);
      return;
    }

    // ≥2 Options: Kachel-Auswahl anzeigen
    options.value = resolved;
    isLoading.value = false;

  } catch (err) {
    console.error('SignInView: Konfiguration konnte nicht geladen werden', err);
    hasError.value = true;
    isLoading.value = false;
  }
});
</script>

<style scoped>
.signin-wrapper {
  width: 100%;
}
</style>
